import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05979dbc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=05979dbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05979dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05979dbc')) {
      api.createRecord('05979dbc', component.options)
    } else {
      api.reload('05979dbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05979dbc&scoped=true", function () {
      api.rerender('05979dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/agencyManage/index.vue"
export default component.exports